import {Component, Watch, Vue} from 'vue-property-decorator'
import {Collection, Dictionary, ID, PageCollection, Resource} from 'simpli-web-sdk'

@Component
export class MixinSelect extends Vue {
  collection?: PageCollection<Resource>

  /**
   * Used as checkbox models
   */
  selectedResource: Dictionary<boolean> = {}

  /**
   * The result after triggered the selectedResource
   */
  selectedItems: Resource[] = []

  get selectedIds(): ID[] {
    return Object.keys(this.selectedResource)
      .filter((key) => !!this.selectedResource[key])
      .map((id) => Number(id))
  }

  get selectedIdsOfPage(): ID[] {
    if (!this.collection) return []
    return this.collection.getMany(this.selectedIds).map((item) => item.$id)
  }

  get allSelectedFromPage(): boolean {
    if (!this.collection || !this.collection.items.length) return false
    return this.selectedIdsOfPage.length === this.collection.items.length
  }

  set allSelectedFromPage(val: boolean) {
    if (!this.collection) return
    for (const item of this.collection.items) {
      this.selectedResource[item.$id] = val
    }
  }

  @Watch('selectedIdsOfPage', {deep: true})
  selectedIdsOfPageEvent(ids: ID[]) {
    if (!this.collection) return
    for (const item of this.collection.items) {
      const index = this.selectedItems.findIndex((it) => it.$id === item.$id)
      if (index >= 0) {
        this.selectedItems.splice(index, 1)
      }
    }
    this.selectedItems.push(...this.collection.getMany(ids))
  }

  @Watch('collection', {deep: true, immediate: true})
  collectionEvent(val: Collection<Resource>) {
    for (const item of val.items) {
      const value = this.selectedResource[item.$id]
      if (value === undefined) {
        this.$set(this.selectedResource, item.$id, false)
      }
    }
  }
}
